import RankFive from '@assets/icons/rank-five.svg'
import { Icon } from './Icon'

export const RankFiveIcon = Icon(RankFive)
